import React from "react";
import Logo from "../../assets/images/logo.png";

const LoginSliderPanel = ({ promos = [], title, subtitle, compact = false }) => {
  const [index, setIndex] = React.useState(0);
  const [isFading, setIsFading] = React.useState(false);

  const safeLength = promos?.length ?? 0;

  const goTo = (nextIndex) => {
    if (!safeLength) return;
    if (nextIndex === index) return;
    setIsFading(true);
    setTimeout(() => {
      setIndex(nextIndex);
      setIsFading(false);
    }, 220);
  };

  React.useEffect(() => {
    if (!safeLength) return;
    if (index >= safeLength) setIndex(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [safeLength]);

  React.useEffect(() => {
    if (!safeLength) return;

    const interval = setInterval(() => {
      goTo((index + 1) % safeLength);
    }, 6000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index, safeLength]);

  if (!safeLength) return null;

  const promo = promos[index];

  return (
    <div className={`login-promo ${compact ? "login-promo--compact" : ""}`}>
      <div className="login-promo-content">
        <div className="login-brand">
          <div className="login-brand-title">
            <span className="login-brand-white">{title?.white || "Ref"}</span>
            <span className="login-brand-accent">{title?.accent || "App"}</span>
          </div>

          <div className="login-brand-subtitle">
            {subtitle || "Smarter workflows for modern clinics."}
          </div>
        </div>

        <div className={`promo-card ${isFading ? "is-fading" : ""}`}>
          <div className="promo-tag">{promo.tag}</div>

          <h2 className="promo-title">
            {promo.title}{" "}
            <span className="promo-highlight">{promo.highlight}</span>
          </h2>

          <p className="promo-description">{promo.description}</p>

           <div className="promo-actions">
            {promo?.contact?.href && (
                <a className="promo-contact" href={promo.contact.href}>
                <i className="zmdi zmdi-email" />
                {promo.contact.label}
                </a>
            )}

           
            </div>


          <div className="promo-indicators">
            {promos.map((_, i) => (
              <button
                key={i}
                type="button"
                className={`promo-dot ${i === index ? "active" : ""}`}
                onClick={() => goTo(i)}
                aria-label={`Promo ${i + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="trust-row">
          <div className="trust-badge">
            <i className="zmdi zmdi-shield-security" />
            <span>Safe browsing</span>
          </div>

          <div className="trust-badge">
            <i className="zmdi zmdi-lock-outline" />
            <span>GDPR accordance</span>
          </div>

          <div className="trust-badge">
            <i className="zmdi zmdi-hospital" />
            <span>Dicom viewer FDA approved</span>
          </div>
        </div>
      </div>

      <div className="login-promo-footer">
        <img src={Logo} alt="CoolBrand" className="loginLogoStyle" />
      </div>
    </div>
  );
};

export default LoginSliderPanel;
